export default __webpack_public_path__ + "f7e66b9b9ae98613b6a40027a2372715.png";